import { client } from '@/services/client'
import type { ClientError } from '@educabot/cloud-client'
import type { SignupWithGoogleV1 } from '@educabot/cloud-client/lib/lms/signup/signupWithGoogle'
import { useMutation } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'

export default function useSignupWithGoogle() {
  const query = useMutation<
    AxiosResponse<SignupWithGoogleV1.SignupWithGoogleResponse>,
    ClientError,
    string
  >({
    mutationFn: (token: string) => client.lms.signup.signupWithGoogle({ token }),
  })
  return query
}
